import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

// VFX: Checklist Cascade
// Category: card-animations · Tags: ui, checklist, list, cascade, stagger
export default function UiChecklistCascade900Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const items = ["Plano estruturado", "Roteiro aprovado", "Edição concluída", "Vídeo publicado"];
  return (
    <AbsoluteFill style={{ background: "#0a0e1a", padding: 80, justifyContent: "center" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>
        {items.map((label, i) => {
          const delay = i * 6;
          const enter = spring({ frame: frame - delay, fps, config: { damping: 14, mass: 0.7 } });
          const check = spring({ frame: frame - delay - 6, fps, config: { damping: 18, mass: 0.6 } });
          return (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 24,
              background: "#1e293b", padding: "24px 32px", borderRadius: 18,
              opacity: enter, transform: `translateX(${interpolate(enter, [0, 1], [-60, 0])}px)`,
              border: "1px solid rgba(16,185,129,0.2)",
            }}>
              <div style={{
                width: 56, height: 56, borderRadius: 28,
                background: interpolate(check, [0, 1], [0, 1]) > 0.3 ? "#10b981" : "#334155",
                display: "flex", alignItems: "center", justifyContent: "center",
                transform: `scale(${interpolate(check, [0, 1], [0.5, 1])})`,
              }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12 L10 17 L19 7" stroke="#f8fafc" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"
                    strokeDasharray="30" strokeDashoffset={interpolate(check, [0, 1], [30, 0])} />
                </svg>
              </div>
              <span style={{ color: "#f8fafc", fontSize: 38, fontFamily: "Inter, sans-serif", fontWeight: 600 }}>{label}</span>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
